import React from "react";
import { Link } from "react-router-dom";

interface Tab {
  href: string;
  name: string;
}

interface TabsProps {
  tabs: Tab[];
}

const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  return (
    <div className="flex space-x-4">
      <div className="flex flex-col sm:flex-row w-[100%] items-start sm:items-center gap-4 rounded-lg">
        <div className="flex space-x-2 bg-[#111111] p-1 rounded-full w-full sm:w-auto">
          {tabs.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`flex px-4 py-2 rounded-full font-popins w-full sm:w-auto justify-center text-[#0B0B0B]  ${
                  isActive
                    ? "bg-gray-300 text-black hover:text-black focus:text-black focus-within:text-text-black"
                    : "text-gray-400 hover:bg-[#0B0B0B] hover:text-gray-400 focus:text-gray-400 focus-within:text-gray-400"
                }`}
              >
                {item.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
